import { IApplicationState } from '../../types/redux';

export const selectQueryString = (state: IApplicationState) => state.queryString;
